import { render } from "./NavHeader.vue?vue&type=template&id=dc770422"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__